// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-Tag-Tag-module__Tag";
var _2 = "webpack-components-core-Tag-Tag-module__closeButton";
var _3 = "webpack-components-core-Tag-Tag-module__disabled";
var _4 = "webpack-components-core-Tag-Tag-module__loading";
var _5 = "webpack-components-core-Tag-Tag-module__md";
var _6 = "webpack-components-core-Tag-Tag-module__sm";
export { _1 as "Tag", _2 as "closeButton", _3 as "disabled", _4 as "loading", _5 as "md", _6 as "sm" }
